var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0453 18.124C19.0453 18.124 22.852 14.3174 24.1533 13.0187C28.2373 8.93469 26.1947 0.764023 26.1947 0.764023C26.1947 0.764023 18.024 -1.27864 13.94 2.80669C10.8867 5.86002 8.852 7.96269 8.852 7.96269C8.852 7.96269 3.728 6.89069 0.664 9.95469L17.004 26.2947C20.068 23.2307 19.0453 18.124 19.0453 18.124ZM17.0427 6.14402C18.0853 5.10136 19.772 5.10136 20.8133 6.14402C21.856 7.18536 21.856 8.87202 20.8133 9.91469C19.772 10.956 18.0853 10.956 17.0427 9.91469C16.0013 8.87202 16.0013 7.18669 17.0427 6.14402ZM1.95867 24.9587C1.95867 24.9587 5.95867 24.9587 8.62533 22.292L4.62533 18.292C1.95867 19.6254 1.95867 24.9587 1.95867 24.9587Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.26be9e6e0412af778fa00955d4d9de70.svg";
export { ForwardRef as ReactComponent };